import React from 'react';
import { Flag } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../components/ui/tooltip';
import { formatDateTimeET } from '../../utils/formatters';

/**
 * Small red flag icon shown on an order row when clarification_sent = true
 * and the order is in "clarification" status.
 * Mirrors the FaxIndicator pattern.
 */
const ClarificationSentIndicator = ({ order }) => {
  if (!order) return null;
  if (order.status !== 'clarification') return null;
  if (!order.clarification_sent) return null;

  const sentBy = order.clarification_sent_by_name || 'Unknown';
  const sentAt = order.clarification_sent_at
    ? formatDateTimeET(order.clarification_sent_at)
    : '';

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="clarification-sent-flag"
            className="inline-flex items-center ml-1.5"
          >
            <Flag size={13} className="text-red-500 fill-red-500" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs max-w-52">
          <p className="font-medium">Clarification Sent</p>
          {sentAt && <p className="text-muted-foreground">{sentBy} — {sentAt}</p>}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ClarificationSentIndicator;
